/* tslint:disable */
/* eslint-disable */
/**
 * openapi
 * bales cloud
 *
 * The version of the OpenAPI document: 1.0
 * Contact: test@example.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { GetCallResultTypeSummaries200Response } from '../models';
/**
 * CallResultTypeApi - axios parameter creator
 * @export
 */
export const CallResultTypeApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * コール結果タイプ概要一覧取得API
         * @summary コール結果タイプ概要一覧取得API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCallResultTypeSummaries: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/user/call_result_types/summaries`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CallResultTypeApi - functional programming interface
 * @export
 */
export const CallResultTypeApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CallResultTypeApiAxiosParamCreator(configuration)
    return {
        /**
         * コール結果タイプ概要一覧取得API
         * @summary コール結果タイプ概要一覧取得API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCallResultTypeSummaries(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCallResultTypeSummaries200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCallResultTypeSummaries(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CallResultTypeApi - factory interface
 * @export
 */
export const CallResultTypeApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CallResultTypeApiFp(configuration)
    return {
        /**
         * コール結果タイプ概要一覧取得API
         * @summary コール結果タイプ概要一覧取得API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCallResultTypeSummaries(options?: any): AxiosPromise<GetCallResultTypeSummaries200Response> {
            return localVarFp.getCallResultTypeSummaries(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CallResultTypeApi - interface
 * @export
 * @interface CallResultTypeApi
 */
export interface CallResultTypeApiInterface {
    /**
     * コール結果タイプ概要一覧取得API
     * @summary コール結果タイプ概要一覧取得API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallResultTypeApiInterface
     */
    getCallResultTypeSummaries(options?: AxiosRequestConfig): AxiosPromise<GetCallResultTypeSummaries200Response>;

}

/**
 * CallResultTypeApi - object-oriented interface
 * @export
 * @class CallResultTypeApi
 * @extends {BaseAPI}
 */
export class CallResultTypeApi extends BaseAPI implements CallResultTypeApiInterface {
    /**
     * コール結果タイプ概要一覧取得API
     * @summary コール結果タイプ概要一覧取得API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallResultTypeApi
     */
    public getCallResultTypeSummaries(options?: AxiosRequestConfig) {
        return CallResultTypeApiFp(this.configuration).getCallResultTypeSummaries(options).then((request) => request(this.axios, this.basePath));
    }
}
